import { render, staticRenderFns } from "./step_description_improving_ecology.vue?vue&type=template&id=1654c08c&scoped=true"
import script from "./step_description_improving_ecology.vue?vue&type=script&lang=js"
export * from "./step_description_improving_ecology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654c08c",
  null
  
)

export default component.exports